import React from 'react';

const EmptyTicket = () => {
  return (
    <svg
      width="151px"
      height="145px"
      viewBox="0 0 151 145"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="paiement-à-table---Ecran-0-Copy-2"
          transform="translate(-112.000000, -237.000000)"
          fillRule="nonzero"
        >
          <g id="box-(2)" transform="translate(112.000000, 237.000000)">
            <polygon
              id="Path"
              fill="#7CC4AC"
              points="81.8958149 27.578125 29 56.4302967 75.1041851 81.578125 128 52.7259533"
            ></polygon>
            <polygon
              id="Path"
              fill="#A9D5C8"
              points="31 117.169185 76 141.578125 76 81.9870647 31 57.578125"
            ></polygon>
            <polygon
              id="Path"
              fill="#92CCBA"
              points="130 111.874209 130 55.578125 98.1209656 98.8421656 87 93.4028639 87.0320094 135.578125"
            ></polygon>
            <g
              id="Group"
              transform="translate(11.000000, 4.578125)"
              fill="#C1DDD7"
            >
              <polygon
                id="Path"
                points="73.2038627 73.2138005 90.6033313 90.6736463 137 65.1073614 119.600531 47.6475155"
              ></polygon>
              <polygon
                id="Path"
                points="0.196377152 69.0407245 46.9731677 94.816758 64.6781116 77.0492042 17.9013211 51.2731705"
              ></polygon>
              <polygon
                id="Path"
                points="119.045852 47.0908748 136.881714 29.194245 90.8640188 3.83540373 73.0281569 21.7343387"
              ></polygon>
              <polygon
                id="Path"
                points="2.05793991 25.2389849 19.0405378 42.2804858 64.6781116 17.1325455 47.6955137 0.0910448137"
              ></polygon>
            </g>
            <path
              d="M134.211532,51.5920804 L150.136212,35.6341672 C150.792877,34.9772869 151.101624,34.0479576 150.970291,33.1278638 C150.84011,32.2077701 150.283674,31.4019663 149.470332,30.9540411 L130.325693,20.4197172 C128.898313,19.6346936 127.105735,20.1576578 126.321194,21.588017 C125.537805,23.0195306 126.058529,24.8158493 127.487061,25.6008729 L143.187093,34.2395959 L129.520416,47.9336396 L80.3662267,20.8861136 L94.0317526,7.19206954 L107.845892,14.7940994 C109.273272,15.579123 111.067002,15.0573135 111.850391,13.6257999 C112.634931,12.1954406 112.113056,10.3979673 110.684524,9.61294369 L94.9303453,0.943050933 C93.7806072,0.310414274 92.3520748,0.514751223 91.4258328,1.44408084 L75.5,17.4031487 L59.5741672,1.44408084 C58.6467733,0.514751223 57.2182408,0.311568646 56.0696547,0.943050933 L1.52966794,30.9540411 C0.716326222,31.4019663 0.159889717,32.2066154 0.0297087159,33.1278638 C-0.101623959,34.0479576 0.207123378,34.9772869 0.863787637,35.6341672 L16.7884681,51.5920804 L0.863787637,67.5488395 C0.207123378,68.2068738 -0.101623959,69.1350488 0.0297087159,70.0562972 C0.159889717,70.9763909 0.716326222,71.7821947 1.52966794,72.2289653 L18.0107849,81.2982966 L18.0107849,111.611752 C18.0107849,112.691159 18.5971747,113.683983 19.5406971,114.203484 L74.0806839,144.21332 C74.5230681,144.456908 75.0115341,144.578125 75.5,144.578125 C75.9884659,144.578125 76.4769319,144.456908 76.9193161,144.21332 L131.459303,114.203484 C132.402825,113.683983 132.989215,112.691159 132.989215,111.611752 L132.989215,81.2982966 L149.470332,72.2301196 C150.283674,71.7821947 150.84011,70.9763909 150.970291,70.0562972 C151.101624,69.1362031 150.792877,68.2068738 150.136212,67.5499938 L134.211532,51.5920804 Z M75.5,78.2297781 L27.0877263,51.590926 L75.5,24.9509195 L123.912274,51.590926 L75.5,78.2297781 Z M56.9693997,7.19206954 L70.6337733,20.8861136 L21.4795844,47.9336396 L7.81405876,34.2395959 L56.9693997,7.19206954 Z M21.4818886,55.2493667 L70.6360773,82.2968928 L56.9693997,95.9920912 L7.81405876,68.9445652 L21.4818886,55.2493667 Z M127.090758,109.86392 L78.4492283,136.628607 L78.4492283,106.417897 C78.4492283,104.78551 77.128988,103.462514 75.5,103.462514 C73.871012,103.462514 72.5507717,104.78551 72.5507717,106.417897 L72.5507717,136.628607 L23.9092415,109.86392 L23.9092415,84.5446001 L56.0696547,102.24111 C56.5154948,102.485852 57.0039608,102.605915 57.4878186,102.605915 C58.2516227,102.605915 59.0073624,102.308068 59.5741672,101.74008 L75.5,85.7810123 L91.4258328,101.74008 C91.9926376,102.309222 92.7483773,102.605915 93.5121814,102.605915 C93.9960392,102.605915 94.4845052,102.485852 94.9303453,102.24111 L127.090758,84.5446001 L127.090758,109.86392 Z M94.0317526,95.9920912 L80.3650747,82.2957384 L129.519263,55.2493667 L143.187093,68.9434108 L94.0317526,95.9920912 Z"
              id="Shape"
              fill="#262957"
            ></path>
            <path
              d="M119,21.578125 C119.788672,21.578125 120.559766,21.2570314 121.121094,20.6980471 C121.678906,20.1402343 122,19.3667971 122,18.578125 C122,17.7882814 121.678906,17.0148439 121.121094,16.4570314 C120.563281,15.8980471 119.788672,15.578125 119,15.578125 C118.207813,15.578125 117.436719,15.8980471 116.878906,16.4570314 C116.317578,17.0148439 116,17.7882814 116,18.578125 C116,19.3667971 116.317578,20.1402343 116.878906,20.6980471 C117.436719,21.2570314 118.211328,21.578125 119,21.578125 Z"
              id="Path"
              fill="#262957"
            ></path>
            <path
              d="M76,93.578125 C75.2113282,93.578125 74.4367186,93.8980471 73.8789064,94.4570314 C73.3210936,95.0171875 73,95.7882814 73,96.578125 C73,97.3691407 73.3210936,98.1402343 73.8789064,98.7015625 C74.4367186,99.259375 75.2113282,99.578125 76,99.578125 C76.7886718,99.578125 77.5632814,99.259375 78.1210936,98.7015625 C78.6789064,98.1402343 79,97.3691407 79,96.578125 C79,95.7882814 78.6789064,95.0171875 78.1210936,94.4570314 C77.5632814,93.8980471 76.7886718,93.578125 76,93.578125 Z"
              id="Path"
              fill="#262957"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EmptyTicket;
